/**
 * @fileoverview GET handler for the app-group-wide WhatsApp template search endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplates } from "./constants";
import type { GetWhatsAppMessageTemplatesQueryParams, GetWhatsAppMessageTemplatesResponse } from "./types";

export const getEngagementAppGroupIdWhatsAppMessageTemplates = reactQueryFetcherAdapter(
  engagementAppGroupIdWhatsAppMessageTemplates,
  (
    signal: AbortSignal,
    appGroupId: string,
    queryParams: GetWhatsAppMessageTemplatesQueryParams
  ): Promise<GetWhatsAppMessageTemplatesResponse> => {
    return fetch(`/engagement/${appGroupId}/whats_app/message_templates`, "GET", queryParams, { signal });
  }
);
